<template>
  <div v-if="user">
    <h1>Home</h1>
    <h3>Hi, {{ user.user_first_name }} {{ user.user_last_name }} </h3>
    <p><b>Role: </b>  {{Number(user.user_role) === 0 ? 'Admin' : 'User'}}</p>
  </div>
</template>

<script>
// import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['user']),
  }
};
</script>